import { debounce } from 'lodash'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'

interface SearchBarProps {
    onSearch: (value: string) => void
}

export const SearchBar = ({ onSearch }: SearchBarProps) => {
    const debouncedSearch = debounce(onSearch, 300)

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target
        debouncedSearch(value)
    }

    return (
        <IconField iconPosition="right">
            <InputIcon className="pi pi-search" />
            <InputText placeholder="Keresés..." onChange={handleInputChange} />
        </IconField>
    )
}
